// extracted by mini-css-extract-plugin
module.exports = {"NumberBlock__title":"NumberBlock_NumberBlock__title__Vdo4p"};